<template>
  <el-form
    label-position="top"
    :model="form"
    :rules="rules"
    ref="form"
    class="text-left"
  >
    <el-row :gutter="30">
      <el-col :span="24" :sm="12">
        <el-form-item label="ชื่อหลักสูตร" prop="courseName">
          <el-input v-model="form.courseName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item label="สถานะหลักสูตร" prop="status-course">
          <el-select
            v-model="form.statusCourse"
            placeholder="กรุณาเลือกสถานะหลักสูตร"
            class="status-course"
            :class="
              form.statusCourse == 0 || form.statusCourse == 3
                ? 'color-gray-lighter'
                : form.statusCourse == 1
                ? 'color-warning'
                : 'color-success'
            "
          >
            <el-option
              label="ยังไม่เปิดรับสมัคร"
              :value="0"
              class="color-gray-lighter"
            >
            </el-option>
            <el-option label="เปิดรับสมัคร" :value="1" class="color-warning">
            </el-option>
            <el-option
              label="เปิดเรียน online"
              :value="2"
              class="color-success"
            >
            </el-option>
            <el-option
              label="ปิดหลักสูตร"
              :value="3"
              class="color-gray-lighter"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="30">
      <el-col :span="24" :sm="12" class="range-open pd-b-4">
        <el-form-item
          label="ระยะเวลาในการเปิด-ปิดหลักสูตร"
          prop="courseDistanceDate"
          class="time-text"
        >
          <el-row :gutter="30">
            <el-col :span="24" :sm="11" class="position-relative">
              <el-date-picker
                v-model="form.courseDistanceDate[0]"
                type="date"
                format="d MMMM yyyy"
                class="date-start width-100"
                :disabled="
                  type == 'update' && statusCourseOld != 0 ? true : false
                "
                :picker-options="{
                  disabledDate(time) {
                    return (
                      time.getTime() >
                      new Date(form.courseDistanceDate[1]).getTime()
                    );
                  },
                }"
              >
              </el-date-picker>
              <span class="color-gray time-duration-date left text-font-12"
                >เวลา 0.00 น.</span
              >
            </el-col>
            <el-col :span="24" :sm="2" class="text-center" style="padding: 0">
              <span>ถึง</span>
            </el-col>
            <el-col :span="24" :sm="11" class="position-relative ">
              <el-date-picker
                v-model="form.courseDistanceDate[1]"
                type="date"
                format="d MMMM yyyy"
                class="date-end width-100"
                :picker-options="{
                  disabledDate(time) {
                    return (
                      time.getTime() <
                      new Date(form.courseDistanceDate[0]).getTime()
                    );
                  },
                }"
              >
              </el-date-picker>
              <span
                class="color-gray time-duration-date right text-font-12 show-in-desktop"
                >เวลา 23.59 น.</span
              >
              <span
                class="color-gray time-duration-date left text-font-12 show-in-mobile "
                >เวลา 23.59 น.</span
              >
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item label="จำนวนวิชาในหลักสูตร" prop="courseSubject">
          <el-input v-model="form.courseSubject"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- <el-col :span="24" :sm="12" class="set-timeLearn">
        <el-form-item label="เวลาเรียนทั้งหมด" prop="timeLearn">
          <el-input
            v-model="form.timeLearn.hour"
            class="input-time-learn"
          ></el-input>
          <span class="mg-l-4">ชั่วโมง</span>
          <el-input
            v-model="form.timeLearn.min"
            class="mg-l-2 input-time-learn"
          ></el-input>
          <span class="mg-l-4">นาที</span>
        </el-form-item>
      </el-col> -->
    <el-row :gutter="30">
      <el-col :span="24" :sm="12">
        <el-form-item label="ภาพประกอบหลักสูตร" prop="courseImageIntro">
          <el-upload
            v-if="form.courseImageIntro == ''"
            class="upload-input-text"
            action="#"
            list-type="picture-card"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="uploadCourseImageIntro"
          >
            <template slot="trigger">
              <div class="flex-display">
                <el-input class></el-input>
                <el-button type="primary" class="light mg-l-4"
                  >แนบไฟล์</el-button
                >
              </div>
            </template>
          </el-upload>

          <div
            v-else
            class="image-preview-course"
            :style="`background-image:url(` + courseImageIntroUrl + `);`"
          >
            <i
              @click="delCourseImageIntroUrl"
              class="fas fa-times-circle icon-preview-image"
            ></i>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item
          :label="
            form.courseVideoIntro == ''
              ? 'Video แนะนำหลักสูตร (รองรับไฟล์ .ogg .mp4 .mpg .mpeg .wmv .avi ขนาดไม่เกิน 800 MB)'
              : ''
          "
          prop="courseVideoIntro"
        >
          <div :class="{ 'show-preview': form.courseImageIntro != '' }">
            <el-upload
              v-if="form.courseVideoIntro == ''"
              class="upload-input-text"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="uploadCourseVideoIntro"
            >
              <template slot="trigger">
                <div class="flex-display">
                  <el-input
                    v-model="form.courseVideoIntro.name"
                    class
                  ></el-input>
                  <el-button type="primary" class="light mg-l-4"
                    >แนบไฟล์</el-button
                  >
                </div>
              </template>
            </el-upload>
            <p v-else class="pd-b-4">
              Introduction แนะนำหลักสูตร
              <span  class="text-underline color-primary-light">
                <a :href="typeof form.courseVideoIntro.default != 'undefined'?`${urlCouse}${courseId}/${form.courseVideoIntro.file}`:'#'" target="_blank" :class="{'pointer-events-none':typeof form.courseVideoIntro.default === 'undefined'}">
                {{
                  typeof form.courseVideoIntro.name != "undefined"
                    ? form.courseVideoIntro.name
                    : form.courseVideoIntro.default
                }}
                </a>
                <i
                  @click="delCourseVideoIntro"
                  class="fas fa-times-circle color-gray-lighter pd-l-5 cursor-pointer"
                ></i>
              </span>
            </p>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          label="แนบไฟล์เอกสารประกอบการเรียน (รองรับไฟล์ .jpg, .jpeg, .png, doc, .docx, .xls, .xlsx, .pdf, .ppt, .pptx  ขนาดไม่เกิน 25 MB )"
          prop="courseDocuments"
        >
          <div v-for="(item, index) in form.courseDocuments" :key="index">
            <el-upload
              v-if="item.name == ''"
              class="upload-input-text"
              :class="{ 'pd-t-4': index > 0 }"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="(file) => uploadCourseDocuments(file, index)"
            >
              <template slot="trigger">
                <div class="flex-display ai-center file-input">
                  <el-input v-model="item.name" class></el-input>
                  <el-button type="primary" class="light mg-l-4"
                    >แนบไฟล์</el-button
                  >
                </div>
              </template>
            </el-upload>

            <p v-else class="color-primary mg-y-less">
              <i
                :class="`fas ${getFileIcon(item.type).name} text-font-16`"
                :style="`color:${getFileIcon(item.type).color}`"
              ></i>
              <span  class="text-font-12 pd-l-5 mg-y-less">
                <a :href="typeof item.default != 'undefined'?`${urlCouse}${courseId}/${item.file}`:'#'" target="_blank" :class="{'pointer-events-none':typeof item.default === 'undefined'}">
                  {{
                    typeof item.name != "undefined" ? item.name : item.default
                  }}
                </a>
                <i
                  @click="delCourseDocuments(index)"
                  class="fas fa-times-circle color-gray-lighter pd-l-5 cursor-pointer"
                ></i>
              </span>
            </p>
          </div>

          <a @click="addCourseDocuments" class="color-primary-light"
            >+ เพิ่มเอกสารประกอบการเรียน</a
          >
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="30">
      <el-col :span="24">
        <el-form-item label="คำอธิบายหลักสูตร">
          <yimo-vue-editor
            v-model="form.courseDescription"
            @input="clearText(form.courseDescription)"
          ></yimo-vue-editor>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          label="แนบไฟล์คำอธิบายหลักสูตร (รองรับไฟล์ .jpg, .jpeg, .png, doc, .docx, .xls, .xlsx, .pdf, .ppt, .pptx  ขนาดไม่เกิน 25 MB )"
        >
          <div v-for="(item, index) in form.courseDescriptionFile" :key="index">
            <el-upload
              v-if="item.name == ''"
              class="upload-input-text"
              :class="{ 'pd-t-4': index > 0 }"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="(file) => uploadCourseDescriptionFile(file, index)"
            >
              <template slot="trigger">
                <div class="flex-display ai-center file-input">
                  <el-input class></el-input>
                  <el-button type="primary" class="light mg-l-4"
                    >แนบไฟล์</el-button
                  >
                </div>
              </template>
            </el-upload>
            <p v-else class="color-primary mg-y-less">
              <i
                :class="`fas ${getFileIcon(item.type).name} text-font-16`"
                :style="`color:${getFileIcon(item.type).color}`"
              ></i>
              <span class="text-font-12 pd-l-5 mg-y-less">
                <a :href="typeof item.default != 'undefined'?`${urlCouse}${courseId}/${item.file}`:'#'" target="_blank" :class="{'pointer-events-none':typeof item.default === 'undefined'}">
                  {{
                    typeof item.name != "undefined" ? item.name : item.default
                  }}
                </a>
                <i
                  @click="delCourseDescriptionFile(index)"
                  class="fas fa-times-circle color-gray-lighter pd-l-5 cursor-pointer"
                ></i>
              </span>
            </p>
          </div>
          <a @click="addCourseDescriptionFile" class="color-primary-light"
            >+ เพิ่มเอกสารคำอธิบายหลักสูตร</a
          >
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="30">
      <el-col :span="24" :sm="12">
        <el-form-item
          label="ตั้งค่า % การผ่านของหลักสูตรนี้"
          prop="coursePercentPass"
        >
          <el-select
            v-model="form.coursePercentPass"
            placeholder="Select"
            class="w-100"
          >
            <el-option
              v-for="item in pecentPassList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item
          label="ตั้งค่าจำนวนครั้งในการทำแบบทดสอบหลังเรียน (Post-Test) "
          prop="courseSetCount"
        >
          <el-select
            v-model="form.courseSetCount"
            placeholder="Select"
            class="w-100"
          >
            <el-option
              v-for="item in countTestList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select> </el-form-item
      ></el-col>
    </el-row>
    <div class="text-center pd-y-3">
      <el-button
        v-if="type == 'add'"
        @click="createCourse"
        type="primary"
        round
        class="pd-x-1"
        >เพิ่มหลักสูตร</el-button
      >
      <el-button
        v-if="type == 'update'"
        @click="updateCourse"
        type="primary"
        round
        class="pd-x-1"
        >บันทึก</el-button
      >
    </div>
  </el-form>
</template>

<script>
import {
  getFileIcon,
  isFileImage,
  isFileVideo,
  isFileDocumnet,
} from "@/service/file";
import { clearText } from "@/service/editor";

export default {
  props: {
    type: {
      type: String,
      default() {
        return "add";
      },
    },
    course: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  computed: {
    courseImageIntroUrl() {
      if (typeof this.form.courseImageIntro.name != "undefined") {
        return this.form.courseImageIntro.url;
      } else {
        return `${this.urlCouse}${this.courseId}/${this.form.courseImageIntro.file}`;
      }
    },
  },
  data() {
    var validateTimeLearn = (rule, value, callback) => {
      if (value.hour == "" && value.min == "") {
        callback(new Error("กรุณากรอกเวลาเรียนทั้งหมด"));
      } else if (
        isNaN(Number(value.hour)) ||
        isNaN(Number(value.min)) ||
        Number(value.hour) < 0 ||
        Number(value.min) < 0
      ) {
        callback(new Error("กรุณากรอกเวลาเรียนทั้งหมดให้ถูกต้อง"));
      } else {
        callback();
      }
    };
    var validatePercent = (rule, value, callback) => {
      if (value < 0 || value > 100) {
        callback(new Error("กรุณากรอก % การผ่านของหลักสูตรนี้ให้ถูกต้อง"));
      } else {
        callback();
      }
    };
    var validateNumber = (rule, value, callback) => {
      let regx = /^[0-9]+$/i;
      if (!regx.test(value)) {
        callback(new Error("กรุณากรอกจำนวนวิชาเป็นตัวเลข"));
      } else {
        callback();
      }
    };
    return {
      statusCourseOld: null,
      form: {
        courseName: "",
        courseSubject: "",
        courseDistanceDate: [],
        timeLearn: { hour: "", min: "" },
        courseImageIntro: "",
        courseVideoIntro: "",
        courseDocuments: [{ name: "", type: "" }],
        courseDescription: "",
        courseDescriptionFile: [{ name: "", type: "" }],
        coursePercentPass: "",
        courseSetCount: "",
        statusCourse: "",
      },
      rules: {
        courseName: [
          {
            required: true,
            message: "กรุณากรอกชื่อหลักสูตร",
            trigger: "blur",
          },
        ],
        courseSubject: [
          {
            required: true,
            message: "กรุณากรอกจำนวนวิชา",
            trigger: "blur",
          },
          { validator: validateNumber, trigger: "blur" },
        ],
        courseDistanceDate: [
          {
            required: true,
            message: "กรุณาเลือกระยะเวลาในการเปิด-ปิดหลักสูตร",
            trigger: ["blur", "change"],
          },
        ],
        timeLearn: [
          {
            required: true,
            message: "กรุณากรอกเวลาเรียนทั้งหมด",
            trigger: "blur",
          },
          { validator: validateTimeLearn, trigger: "blur" },
        ],
        coursePercentPass: [
          {
            required: true,
            message: "กรุณากรอก % การผ่านของหลักสูตรนี้",
            trigger: "blur",
          },
          { validator: validatePercent, trigger: "blur" },
        ],
        courseSetCount: [
          {
            required: true,
            message: "กรุณาเลือกจำนวนครั้งในการทำแบบทดสอบหลังเรียน",
            trigger: "blur",
          },
          { validator: validatePercent, trigger: "blur" },
        ],
        courseImageIntro: {
          required: true,
          message: "กรุณาเลือกภาพประกอบหลักสูตร",
        },
      },
      urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE,
      courseId: "",
      courseImageIntroDel: "",
      courseVideoIntroDel: "",
      courseDocumentsDel: [],
      courseDescriptionFileDel: [],
      pecentPassList: [
        {
          value: 50,
          label: "50%",
        },
        {
          value: 55,
          label: "55%",
        },
        {
          value: 60,
          label: "60%",
        },
        {
          value: 65,
          label: "65%",
        },
        {
          value: 70,
          label: "70%",
        },
        {
          value: 75,
          label: "75%",
        },
        {
          value: 80,
          label: "80%",
        },
        {
          value: 85,
          label: "85%",
        },
        {
          value: 90,
          label: "90%",
        },
        {
          value: 95,
          label: "95%",
        },
        {
          value: 100,
          label: "100%",
        },
      ],
      countTestList: [
        {
          value: 1,
          label: "1",
        },
        {
          value: 2,
          label: "2",
        },
        {
          value: 3,
          label: "3",
        },
        {
          value: 4,
          label: "4",
        },
        {
          value: 5,
          label: "5",
        },
        {
          value: 0,
          label: "ไม่จำกัด",
        },
      ],
    };
  },
  watch: {
    course() {
      this.setCouse();
    },
  },
  mounted() {
    this.setCouse();
  },
  methods: {
    setCouse() {
      if (this.course != null) {
        this.form = {
          courseName: this.course.name,
          courseDistanceDate: [
            new Date(this.course.durationTime.open),
            new Date(this.course.durationTime.close),
          ],
          timeLearn: {
            hour: this.course.totalStudyTime.hours,
            min: this.course.totalStudyTime.minute,
          },
          courseImageIntro: this.course.illustration
            ? this.course.illustration
            : "",
          courseVideoIntro: this.course.introduction
            ? this.course.introduction
            : "",
          courseDocuments: this.course.studyDocument,
          courseDescription: this.course.courseDescription,
          courseDescriptionFile: this.course.attachDescription,
          coursePercentPass: this.course.percent,
          statusCourse: this.course.statusCourse,
          courseSetCount: this.course.countPostTest,
          courseSubject:
            typeof this.course.subjectNumber !== "undefined"
              ? this.course.subjectNumber
              : "",
        };

        this.courseId = this.$route.query.courseId;
        this.statusCourseOld = this.course.statusCourse;
      }
    },
    uploadCourseDocuments(file, index) {
      var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      if (!this.isFileDocumnet(file.name)) {
        this.$message.error("ไม่รองรับไฟล์ที่อัพโหลด");
      } else if (sizeInMB > 25) {
        this.$message.error("ไฟล์ที่อัพโหลดขนาดใหญ่เกินกว่าที่รองรับ");
      } else {
        this.form.courseDocuments[index].name = file.name;
        this.form.courseDocuments[index].type = file.raw.type;
        this.form.courseDocuments[index] = file;
      }
    },
    addCourseDocuments() {
      this.form.courseDocuments.push({ name: "", type: "" });
    },
    delCourseDocuments(index) {
      if (typeof this.form.courseDocuments[index].name == "undefined") {
        this.courseDocumentsDel.push(this.form.courseDocuments[index].file);
      }
      this.form.courseDocuments.splice(index, 1);
    },
    uploadCourseDescriptionFile(file, index) {
      var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      if (!this.isFileDocumnet(file.name)) {
        this.$message.error("ไม่รองรับไฟล์ที่อัพโหลด");
      } else if (sizeInMB > 25) {
        this.$message.error("ไฟล์ที่อัพโหลดขนาดใหญ่เกินกว่าที่รองรับ");
      } else {
        this.form.courseDescriptionFile[index].name = file.name;
        this.form.courseDescriptionFile[index].type = file.raw.type;
        this.form.courseDescriptionFile[index] = file;
      }
    },
    addCourseDescriptionFile() {
      this.form.courseDescriptionFile.push({ name: "", type: "" });
    },
    delCourseDescriptionFile(index) {
      if (typeof this.form.courseDescriptionFile[index].name == "undefined") {
        this.courseDescriptionFileDel.push(
          this.form.courseDescriptionFile[index].file
        );
      }
      this.form.courseDescriptionFile.splice(index, 1);
    },
    uploadCourseImageIntro(file) {
      this.rules.courseImageIntro.required = false;
      if (this.isFileImage(file.raw.type)) {
        this.form.courseImageIntro = file;
      } else {
        this.$message.error("กรุณาอัพโหลดไฟล์ให้ถูกต้อง");
      }
    },
    delCourseImageIntroUrl() {
      this.rules.courseImageIntro.required = true;
      if (typeof this.form.courseImageIntro.name == "undefined") {
        this.courseImageIntroDel = this.form.courseImageIntro.file;
      }

      this.form.courseImageIntro = "";
    },
    uploadCourseVideoIntro(file) {
      var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      if (!this.isFileVideo(file.raw.type)) {
        this.$message.error("ไม่รองรับไฟล์ที่อัพโหลด");
      } else if (sizeInMB > 800) {
        this.$message.error("ไฟล์ที่อัพโหลดขนาดใหญ่เกินกว่าที่รองรับ");
      } else {
        this.form.courseVideoIntro = file;
      }
    },
    delCourseVideoIntro() {
      if (typeof this.form.courseVideoIntro.name == "undefined") {
        this.courseVideoIntroDel = this.form.courseVideoIntro.file;
      }
      this.form.courseVideoIntro = "";
    },
    createCourse() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.courseImageIntro != "") {
            this.$emit("createCourse", this.form);
          } else {
            this.$message.error("กรุณาอัพโหลดไฟล์ภาพประกอบหลักสูตร");
          }
        }
      });
    },
    updateCourse() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.courseImageIntro != "") {
            let obj = {
              courseImageIntroDel: this.courseImageIntroDel,
              courseVideoIntroDel: this.courseVideoIntroDel,
              courseDocumentsDel: this.courseDocumentsDel,
              courseDescriptionFileDel: this.courseDescriptionFileDel,
            };

            this.$emit("updateCourse", this.form, obj);
          } else {
            this.$message.error("กรุณาอัพโหลดไฟล์ภาพประกอบหลักสูตร");
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.input-time-learn {
  width: 130px;
}

.image-preview-course {
  width: 370px;
  height: 200px;

  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  border-radius: 5px;
  position: relative;
}
.icon-preview-image {
  position: absolute;
  right: -4px;
  top: -4px;
  color: #c4c4c4;
  cursor: pointer;
  background: #fff;
  border-radius: 20px;
}
.show-preview {
  height: 230px;
}
</style>
